import {createContext} from "react";

export const MissionModelListContext = createContext({
    missionModels: [],
    selectedModel: {},
    openDeleteMissionModelModal: false,
    openValidModificationToast: false,
    loading: false,
    history: {},
    location: {},
    hasBeenModified: null,
    setSelectedModel: () => {},
    setOpenDeleteMissionModelModal: () => {},
    setOpenValidModificationToast: () => {},
    setLoading: () => {},
    handlePatchModel: () => {},
    handleEditeMissionModel: () => {},
    handleOpenDeleteMissionModelModal: () => {},
    handleDeleteModel: () => {},
    handleCloseValidModificationToast: () => {}
})

